import { getObjectListByPropertyApi } from 'api/general';
import SubjectDataTable from 'app/components/DataTable/subject/SubjectDataTable';
import LoadingPopUp from 'app/components/LoadingPopup';
import { alphabeticSorting } from 'app/utils/appHelpers';
import { SUBJECT } from 'app/utils/constants/customConstant';
import React, { useEffect, useState } from 'react';



const ListSubject = () => {

    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const getAPI = async () => {
            const res = await getObjectListByPropertyApi(SUBJECT, "state", "1");
            let data = res.data;
            data = alphabeticSorting(data, 'asc');
            setData(data);
            setLoading(false);
        }
        getAPI()
    }, [])


    const columnData = [

        { id: 'name', align: 'left', disablePadding: false, label: "Konu Adı" },
        { id: 'islemler', align: 'left', disablePadding: false, label: "İşlemler" }
    ];


    return (
        <React.Fragment>

            <>
                <LoadingPopUp open={loading} />
                {!loading && <SubjectDataTable mainData={data} column={columnData} pageTitle="Konu Listesi" />}
            </>



        </React.Fragment>
    );
};

export default ListSubject;